import React, { useState, useEffect } from 'react';
import { getGlobalData } from "../lib/globalData"
import Slider from '../lib/slider';
import Info from '../lib/info';
import StripeForm from '../lib/StripeForm';
import PostFinanceForm from '../lib/PostFinanceForm';
import moment from 'moment';

const Invoice = props => {

  const { dataprovider, staticel, params, id, is_dev } = props;
  require('moment/locale/de');
  moment.locale('de');
  
  var get = {};
  if (params) {
    var parts = params.split("&");
    for (var i = 0; i < parts.length; i++) {
      var temp = parts[i].split("=");
      get[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
    }
  }
  
  const [invoice, setInvoice] = useState([]);
  const [detailID, setDetailID] = useState(parseInt(id));
  const [detail, setDetail] = useState({});
  const [assets, setAssets] = useState([]);
  const [payCC, setPayCC] = useState(false);
  const [reload, setReload] = useState(0);
  const [infoMsg, setInfoMsg] = useState(false);

  useEffect(() => {
    // Rueckkehr von einem Stripe-Redirect (z.B. Twint-App-Wechsel) kann auf einem
    // beliebigen bestehenden Hash landen (z.B. #invoice/xxxr, wenn urspruenglich eine
    // Vorauskasse-Rechnung offen war). StripeForm wird dann aber nie gemountet, weil nur
    // Suffix 'o' OpenPayment() ausloest - daher hier unabhaengig vom Suffix pruefen und
    // payCC direkt aus der URL setzen, statt eine neue PaymentIntent anzulegen.
    const params = new URLSearchParams(window.location.search);
    const clientSecret = params.get('payment_intent_client_secret');
    if (clientSecret) {
      setPayCC(clientSecret);
    }
  }, []);

  useEffect(() => {
    if (id && id.substr(-1)==='r') {
      setInfoMsg(['Bestellung Vorauskasse',(<span><p>Du hast die Rechnung per Mail erhalten.</p><p>Freischaltung / Versand erfolgt nach Zahlungseingang.</p><p>Du kannst die Rechnung auch direkt hier online begleichen.</p></span>)]);
    }
    else if (id && id.substr(-1)==='o') {
      OpenPayment();
    }
    else if (id && id.substr(-1)==='s') {
      setInfoMsg(['Wir prüfen deine Zahlung',(<span><p>Wir haben deine Zahlung erhalten und prüfen sie gerade.</p><p>Die Verbuchung kann einen kurzen Moment dauern.</p></span>)]);
      PollPfcInvoicePaid(parseInt(id), 10);
    }
    else if (id && id.substr(-1)==='f') {
      setInfoMsg(['Zahlung fehlgeschlagen',(<span><p>Die Zahlung wurde abgebrochen oder ist fehlgeschlagen.</p><p>Bitte versuche es erneut.</p></span>)]);
    }
  }, [id]);

  useEffect(() => {
    dataprovider.getList('invoice', {}, setInvoice);
  }, [dataprovider, reload]);
  
  useEffect(() => {
    if (detailID > 0) {
      dataprovider.getRow('invoice', detailID, '', setDetail);
      dataprovider.getList('asset', {filter:{id_invoice:detailID}}, setAssets);
    }
    else {
      setDetail({})
    }
  }, [dataprovider, detailID]);
  
  const handleSetDetail = (id) => (ev) => {
    setDetailID(id);
  }

  const setPaymentIntent = (data) => {
    if (data.pics) {
      setPayCC(data.pics);
    }
  }
  const OpenPayment = () => {
    dataprovider.getRow('payment', detailID, '', setPaymentIntent);
  }
  const DoneCancelPayment = () => {
    setDetailID(0);
    setReload((prev) => prev + 1);
  }
  const CancelPayment = () => {
    dataprovider.getRow('payment/cancel', detailID, '', DoneCancelPayment);
  }
  const PaySucess = () => {
    console.log('PaySucess');
    setPayCC(false);
    const inv = [];
    for (var i=0;i<invoice.length;i++) {
      inv.push({...invoice[i], status:invoice[i].id===detailID?'paid':invoice[i].status});
    }
    setInvoice(inv);
    setDetail({...detail, status:'paid'})
    setInfoMsg(['Wir haben deine Zahlung erhalten!',(
      <span><p>Linzenzen und Print@home Produkte werden in wenigen Sekunden freigeschaltet.</p><p>Die Rechnung als Kaufbeleg findest du hier.</p></span>)]);
  }
  const PayReceived = () => {
    console.log('PayReceived');
    setPayCC(false);
    setInfoMsg(['Zahlung eingegangen',(
      <span><p>Wir haben deine Twint-Zahlung erhalten.</p><p>Die Verbuchung kann einen kurzen Moment dauern.</p></span>)]);
    setReload((prev) => prev + 1);
  }
  // Nach der Rueckkehr von PostFinance Checkout ist die Zahlung bereits erfolgt,
  // aber der Webhook (der status='paid' setzt) kann noch ein paar Sekunden brauchen.
  // Deshalb hier kurz pollen, analog zum Stripe-TWINT-Polling in StripeForm.js.
  const PollPfcInvoicePaid = (iid, attemptsLeft) => {
    dataprovider.getRow('invoice', iid, '', (res) => {
      setDetail(res);
      if (res && res.status === 'paid') {
        setReload((prev) => prev + 1);
        setInfoMsg(['Wir haben deine Zahlung erhalten!',(
          <span><p>Linzenzen und Print@home Produkte werden in wenigen Sekunden freigeschaltet.</p><p>Die Rechnung als Kaufbeleg findest du hier.</p></span>)]);
      }
      else if (attemptsLeft > 0) {
        setTimeout(() => PollPfcInvoicePaid(iid, attemptsLeft - 1), 3000);
      }
      else {
        setReload((prev) => prev + 1);
        setInfoMsg(['Die Verbuchung dauert länger als erwartet',(
          <span><p>Wir haben deine Zahlung erhalten, die Verbuchung dauert aber ungewöhnlich lange.</p><p>Lade die Seite in ein paar Minuten neu, um den aktuellen Status zu sehen.</p></span>)]);
      }
    });
  }
  const ClosePay = () => {
    setPayCC(false);
  }
  
  const token = getGlobalData('token');

  var total = 0;
  return (
    <>
      <Slider staticel={staticel} page={10} is_dev={is_dev} />
      <div className="py-5 bg-light">
        <div className="container mt-2">
          <div className="row align-items-top">
            <div className="col-12 col-lg-6 col-sm-12">
              <div className="row p-3 align-items-center">
                <div className="col-3 col-lg-1">Nr.</div>
                <div className="col-2">Status</div>
                <div className="col-6 col-lg-4">Zeit</div>
                <div className="col-6 col-lg-2">Betrag</div>
              </div>
              <div className="row">
      {!invoice.length && <h2>Noch keine Rechnung</h2>}
      {invoice.map(el => {
        return (
                <div className="row mb-3 p-3 align-items-center" style={{backgroundColor:'#f2f2f2', borderRadius:'15px'}} key={el.id}>
                  <div className="col-3 col-lg-1">{el.id}</div>
                  <div className="col-2">{el.status==='open'?'offen':'bezahlt'}</div>
                  <div className="col-6 col-lg-4">{moment(el.timestamp).format('Do MMM YYYY HH:mm')}</div>
                  <div className="col-6 col-lg-2">CHF {el.amount.toFixed(2)}</div>
                  <div className="col-6 col-lg-3">
                    <a href={'https://'+dataprovider.apiUrl+"/invoice/"+el.id+"?token="+token+"&qr=2"} className="btn btn-secondary" target="_blank" rel="noreferrer"><i className="bi bi-printer"></i></a>
                    <button className="btn btn-secondary ms-2" target="_blank" rel="noreferrer" onClick={handleSetDetail(el.id)}><i className="bi bi-chevron-right"></i></button>
                  </div>
                </div>
      )})}
              </div>
            </div>
            <div className="col-12 col-lg-6 p-3" style={{backgroundColor:'#f2f2f2', borderRadius:'15px'}}>
      {detailID>0 && (
              <>
                <div className="row">
                  <div className="col-4">Rechnungsnummer</div><div className="col-8">{detail.id}</div>
                </div>
                <div className="row">
                  <div className="col-4">Bestelldatum</div><div className="col-8">{moment(detail.timestamp).format('Do MMM YYYY HH:mm')}</div>
                </div>
                <div className="row">
                  <div className="col-4">Status</div><div className="col-8">{detail.status==='open'?'offen':'bezahlt'}</div>
                </div>
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Produkt</th><th>Versand</th><th>Menge</th><th>Preis</th>
                    </tr>
                  </thead>
                  <tbody>
        {assets.map(as=> {

          let preis = parseFloat(as.price) * parseFloat(as.count);
          const pen = as.pen.split('/');
          let bogen = 0;
          if (as.id_project) {
            const size = pen[1]?pen[1]:20;
            if (size.includes("x")) {
              const s = size.split("x");
              bogen = Math.ceil(as.anzSticker / (s[0]*s[1])) * as.count;
            }
            else {
              bogen = Math.ceil(as.count * as.anzSticker / (size==="60"?12:(size==="40"?24:88)));
            }
            preis = parseFloat(as.price) * bogen;
          }
          as.preis = preis;
          as.bogen = bogen;
          total += preis;
          const versandtext = {no:'', notpaid:'Zahlung offen', prepare:'In Vorbereitung', sent:'Versandt'};
          return (
                    <tr key={as.id}>
                      <td>{as.title?as.title:as.text}</td>
                      <td>{versandtext[as.deliver]}</td>
                      <td>{as.count}{as.bogen?' ('+as.bogen+' Bogen)':''}</td>
                      <td>CHF {as.preis.toFixed(2)}</td>
                    </tr>
        )})}
                  </tbody>
                  <tfoot className="fw-bold">
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td></td>
                      <td>CHF {total.toFixed(2)}</td>
                    </tr>
                  </tfoot>
                </table>
                <div className="col text-center">
                  <a href={"https://"+dataprovider.apiUrl+"/invoice/"+detail.id+"?token="+token+"&qr=2"} className="btn btn-primary" target="_blank" rel="noreferrer">PDF herunterladen</a>
                </div>
                <hr />
        {detail.status==='open' &&
          <>
                <div className="row align-items-top">
                  <div className="col-12 col-lg-6">
                    <p>Bezahlen mit Twint (alixon gmbh) oder Kreditkarte</p>
                    <button className="btn btn-primary" onClick={OpenPayment}>Jetzt bezahlen</button>
                  </div>
                  <div className="col-12 col-lg-6">
                    <p>Bezahlen per E-Banking</p>
                    <img src={"https://"+dataprovider.apiUrl+"/invoice/"+detail.id+"?token="+token+"&qr=1"} className="w-100" alt="QR-Code" />
                  </div>
                </div>
                <div className="row align-items-top">
                  <div className="col-12">
                    <hr />
                    <button className="btn btn-primary" onClick={CancelPayment}>Bestellung stornieren</button>
                  </div>
                </div>
          </>
        }
              </>
      )}          
            </div>
          </div>
        </div>
      {payCC && typeof payCC === 'string' &&
        <StripeForm amount={total} pics={payCC} CloseModal={ClosePay} PaySucess={PaySucess} PayReceived={PayReceived} is_dev={is_dev} />
      }
      {payCC && typeof payCC !== 'string' &&
        <PostFinanceForm amount={total} pics={payCC} CloseModal={ClosePay} />
      }
    </div>
    <Info msg={infoMsg} setMsg={setInfoMsg} />
    </>
  )
}

export default Invoice;
